module.exports = __webpack_public_path__ + "img/icon-alert.14cc4d6e.svg";